<template>
    <RecommendedItem :title="$t('LandingPage.recommended_items_topics_title')">
        <PackageCloud />
    </RecommendedItem>
</template>

<script>
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import PackageCloud from 'components/landingpage/PackageCloud'

    export default {
        components: { PackageCloud, RecommendedItem },
    }
</script>
